<template>
  <div class="footer">
    <ul class="connection">
      <li :class="{ hoverScanCode: isCodeImgShow }">
        <span>首旅如家情报局</span>
        <em class="codeImg">
          <img src="../assets/img/code_slrjqbj.jpg" />
          <i class="cdTitle">首旅如家情报局</i>
        </em>
      </li>
      <li :class="{ hoverScanCode: isCodeImgShow }">
        <span>首旅如家人</span>
        <em class="codeImg">
          <img src="../assets/img/code_slrjr.jpg" />
          <i class="cdTitle">首旅如家人</i>
        </em>
      </li>
      <li :class="{ hoverScanCode: isCodeImgShow }">
        <span>首旅如家企业号</span>
        <em class="codeImg">
          <img src="../assets/img/code_slrjqyh.jpg" />
          <i class="cdTitle">首旅如家企业号</i>
        </em>
      </li>
      <li :class="{ hoverScanCode: isCodeImgShow }">
        <span>集团公众号</span>
        <em class="codeImg">
          <img src="../assets/img/code_jtgzh.jpg" />
          <i class="cdTitle">集团公众号</i>
        </em>
      </li>
      <li :class="{ hoverScanCode: isCodeImgShow }">
        <span>首旅如家</span>
        <em class="codeImg">
          <img src="../assets/img/code_zsrj.jpg" />
          <i class="cdTitle">首旅如家</i>
        </em>
      </li>
      <li :class="{ hoverScanCode: isCodeImgShow }">
        <span>早餐管家app</span>
        <em class="codeImg">
          <img src="../assets/img/code_zcgj.jpg" />
          <i class="cdTitle">P2早餐管家app</i>
        </em>
      </li>
      <li :class="{ hoverScanCode: isCodeImgShow }">
        <span>优选商城</span>
        <em class="codeImg">
          <img src="../assets/img/code_yxsc.jpg" />
          <i class="cdTitle">优选商城</i>
        </em>
      </li>
      <!-- <li :class="{ hoverScanCode: isCodeImgShow }">
        <span>酒店管家app</span>
        <em class="codeImg">
          <img src="../assets/img/code_jdgj.jpg" />
          <i class="cdTitle">酒店管家app</i>
        </em>
      </li> -->
      <li :class="{ hoverScanCode: isCodeImgShow }">
        <span>管家宝app</span>
        <em class="codeImg">
          <img src="../assets/img/jdgj_app.png" />
          <i class="cdTitle">管家宝app</i>
        </em>
      </li>
      <li v-if="isCodeImgShow" :class="{ hoverScanCode: isCodeImgShow }">
        <span>
          <a target="_blank" href="/Download.html">资料下载</a>
        </span>
      </li>
      <li v-if="isCodeImgShow" :class="{ hoverScanCode: isCodeImgShow }">
        <span>
          <a href="https://disa.cloudhotels.cn">灾备报表</a>
        </span>
      </li>
    </ul>
    <p class="copyright">
      版权所有 © 2016 Homeinns Co.,Ltd All Rights
      Reserved.和美酒店管理（上海）有限公司 沪ICP备15017896-8号
    </p>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data: function () {
    return {
      isCodeImgShow: true, // p3 不显示扫码图片和 下载链接
    };
  },
  methods: {
  },
  created() {
    //
    this.$nextTick(function () {
      const P3clientID = "20000009";
      const sourceULClientId = document.getElementById("hidClientId").value; // 判断 系统来源
      if (sourceULClientId == P3clientID) {
        this.isCodeImgShow = false;
      }
    });
  },
};
</script>
<style lang="scss" scoped>
@import "@css/style.scss";
.footer {
  /* width: 1200px; */
  margin: 0 auto;
  background-color: #fff;

  .copyright {
    color: #9c9c9c;
    font-size: 12px;
    line-height: 18px;
    text-align: center;
    padding-bottom: 20px;
  }
  .connection {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    text-align: center;
    li {
      cursor: pointer;
      position: relative;
      margin: 9px 0;
      line-height: 18px;
      font-size: 14px;
      margin-top: 10px;
      display: inline-block;
      position: relative;
      border-right: 1px solid #767676;
      padding: 0 12px;
      color: #767676;
      a {
        color: #767676;
        text-decoration: none;
      }
      a:hover {
        color: #f3565d;
      }
      .codeImg {
        display: none;
        width: 160px;
        border-radius: 5px;
        background: #fff;
        box-shadow: 3px 3px rgba(102, 102, 102, 0.1);
        position: absolute;
        bottom: 44px;
        left: -13px;
        padding: 10px;
        z-index: 9999;
        img {
          width: 100%;
          height: auto;
        }
      }
      .codeImg:before {
        width: 0px;
        height: 0px;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-top: 10px solid #fff;
        position: absolute;
        bottom: -10px;
        left: 80px;
        content: "";
      }
    }
    li:last-child {
      border-right: none;
    }
    li.hoverScanCode:hover {
      color: #f3565d;
      .codeImg {
        display: inline;
      }
    }
  }
}
</style>
